import { put, select, takeLatest } from "redux-saga/effects";
import * as standingsActions from "../standings/standingsActions";
import * as scheduleActions from "../schedule/scheduleActions";
import * as scheduleSelectors from "../schedule/scheduleSelectors";
import * as uiActions from "./uiActions";

function* uiSaga() {
  yield takeLatest("POST_EDIT_RESULT_FULFILLED", reloadData);
}

function* reloadData(action) {
  const { meta } = action;
  const division = yield select(
    scheduleSelectors.getDivisionByMatchId,
    meta.matchId
  );
  yield put(uiActions.showToastMessage("Resultat sparat"));
  yield put(standingsActions.fetchStandings(division));
  yield put(scheduleActions.fetchSchedule(division));
}

export default uiSaga;



// WEBPACK FOOTER //
// ./src/store/ui/uiSaga.js